<div class="page">
  @if (hasError()) {
    <procure-page-has-error
      [redirectLabel]="redirectLabel()"
      [redirectUrl]="redirectUrl()"
      (retry)="retry.emit()"
    />
  }
  @if (is404()) {
    <procure-page-not-found />
  }
  @if (!formModeService.isAddMode() && isInvisible()) {
    <procure-page-not-visible [errorDetails]="errorDetails()" />
  }
  @if (isDeleted()) {
    <procure-page-deleted />
  }
  @if (isInMaintenanceMode()) {
    <procure-page-maintenance-mode [maintenanceText]="maintenanceText()" />
  }
  @if (showContent()) {
    <ng-content />
  }
</div>
